function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      resolve(reader.result.split(',')[1]);
    };
    reader.onerror = function (error) {
      reject(error)
    };
  })
}

export { getBase64 }